import { Theme } from "@deere/fuel-react";
import { gridClasses } from "@mui/x-data-grid-pro";

export const invoiceDataGridSx = (theme: Theme) => ({
  border: 1,
  borderColor: theme.tokens.FuelColorBorderLight,
  borderRadius: theme.tokens.FuelBorderRadiusLg,
  "--DataGrid-rowBorderColor": "none",
  [`.MuiDataGrid-withBorderColor`]: {
    borderColor: "transparent",
  },
  [`.${gridClasses.toolbarContainer}`]: {
    borderBottom: 1,
    borderColor: theme.tokens.FuelColorBorderLight,
    padding: "1rem",
  },
  [`& .${gridClasses.columnHeaders} > div[role="row"]`]: {
    borderBottom: 1,
    borderColor: theme.tokens.FuelColorBorderLight,
    backgroundColor: theme.tokens.FuelColorBackgroundWhite,
  },
  [`.${gridClasses.columnHeader}:focus, & .${gridClasses.columnHeader}:focus-within`]:
    {
      outline: "none",
    },
  [`.${gridClasses.headerFilterRow}`]: {
    borderColor: theme.tokens.FuelColorBorderLight,
  },
  [`.${gridClasses.cell}:focus, & .${gridClasses.cell}:focus-within`]: {
    outline: "none",
  },
  [`& .${gridClasses.cell}`]: {
    display: "flex",
    alignItems: "center",
    border: "none",
    paddingY: "1rem",
    paddingLeft: "1rem",
  },
  [`.MuiIconButton-sizeSmall:hover`]: {
    backgroundColor: theme.tokens.FuelColorBorderDark,
  },
  "& .MuiDataGrid-row.Mui-selected .MuiSvgIcon-root": {
    color: theme.tokens.FuelColorGreen700,
  },
  "& .MuiDataGrid-columnHeader .Mui-checked .MuiSvgIcon-root": {
    color: theme.tokens.FuelColorGreen700,
  },
  [`& .${gridClasses.row}`]: {
    borderBottom: 1,
    borderColor: theme.tokens.FuelColorBorderLight,
    alignItems: "center",
    "&:last-child": {
      borderBottom: 0,
    },
  },
  [`& .${gridClasses.checkboxInput}`]: {
    color: theme.tokens.FuelColorGray400,
  },
  [`& .data-row-theme--Unseen`]: {
    boxShadow: `2px 0 0 ${theme.tokens.FuelColorBrandPrimary} inset`,
    fontWeight: `${theme.tokens.FuelFontWeightSemibold} !important`,
    [`& .MuiTypography-root`]: {
      fontWeight: `${theme.tokens.FuelFontWeightSemibold} !important`,
    },
  },
  [`.${gridClasses.overlayWrapper}`]: {
    height: "50vh",
  },
  [`.${gridClasses.overlayWrapperInner}`]: {
    height: "100% !important",
  },
  [`.${gridClasses.menuIcon}`]: {
    width: "auto",
    visibility: "visible",
  },
  "& .MuiDataGrid-cell.MuiDataGrid-cellEmpty": {
    padding: 0,
  },
});
